import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import GeneralDentistry from "./components/GeneralDentistry";
import PediatricDentistry from "./components/PediatricDentistry";
import Articles from "./components/Articles";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/general-dentistry" element={<GeneralDentistry />} />
        <Route path="/pediatric-dentistry" element={<PediatricDentistry />} />
        <Route path="/articles" element={<Articles />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;